import {log} from "@/lib/Logger";
import Campus from "../types/Campus";

export const removeTrailingSlash = (path: string) => {
	if (path.endsWith("/")) {
		return path.slice(0, -1);
	}

	return path;
};

export const NEXT_SITE_URL = removeTrailingSlash(
	process.env.NEXT_PUBLIC_NEXT_SITE_URL ?? ""
);

export const NEXT_SITE_URL_OBJECT = new URL(
	process.env.NEXT_PUBLIC_NEXT_SITE_URL ?? "https://aopsacademy.org"
);

export const isSameNextAppPath = (path1: string, path2: string) => {
	/**
	 * use URL constructor with NEXT_PUBLIC_NEXT_SITE_URL base because we don't
	 * know if href is a fragment.
	 **/
	const nextBaseURL = process.env.NEXT_PUBLIC_NEXT_SITE_URL;
	if (!nextBaseURL) {
		log.warn(
			{
				module: "app/util/urlUtils.ts",
				fn: "isSameNextAppPath",
				label: "NoNextSiteUrl",
			},
			"No env value found for NEXT_PUBLIC_NEXT_SITE_URL"
		);
	}

	const nextUrl = new URL(nextBaseURL ?? "http://localhost");
	const currentLocation = new URL(path1, nextUrl);
	const hrefLocation = new URL(path2, nextUrl);

	return (
		currentLocation.host === hrefLocation.host &&
		removeTrailingSlash(currentLocation.pathname) ===
			removeTrailingSlash(hrefLocation.pathname)
	);
};

function encodeURIPath(redirectPath: string) {
	if (redirectPath && !redirectPath.startsWith("/")) {
		redirectPath = "/" + redirectPath;
	}
	return encodeURIComponent(`${NEXT_SITE_URL}${redirectPath}`);
}

export function getSignInUrl(redirectPath: string) {
	const redirect = encodeURIPath(redirectPath);
	return `${NEXT_SITE_URL}/sign-in?redirect=${redirect}`;
}

export function getSignOutUrl(redirectPath: string) {
	const redirect = encodeURIPath(redirectPath);
	return `${NEXT_SITE_URL}/sign-out?redirect=${redirect}`;
}

export function getCampusTuitionPath(campus: Campus) {
	return `/campus/${campus.campusId}/tuition`;
}
